module.exports = "/images/edit-button-red.svg?2c94f03d3d96fd2736af7edd009204d4";